import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

availabilityStyles.availability = {
    container : {
        css : css` ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`margin-top: 15px; `,
            null,
            null,
            null,
            null,
        ])}`
    }
}